import { render } from "./EmptyState.vue?vue&type=template&id=5e4333d8&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"

import "./EmptyState.vue?vue&type=style&index=0&id=5e4333d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e4333d8"

export default script